import React, { createContext, useEffect } from "react";

// third-party
import jwtDecode from "jwt-decode";

// project import
import Loader from "components/Loader";
import axios from "utils/axios";
import { KeyedObject } from "types/root";
import { JWTContextType } from "types/auth";
import { dispatch, useSelector } from "store";
import {
  loggedInUserData,
  loginUser,
  logoutUser,
  onBoardingStatusUpdate,
  updateStaffData,
  updateRole,
  clearAuth,
} from "store/reducers/auth";
// import ServerConstants from 'utils/ServerConstants';
import publicApi from "interceptor/publicInterceptor";
import { get } from "lodash";
import {
  clearDashboardSearch,
  updateSelectedCompany,
} from "store/reducers/dashboardSearch";
import toast from "utils/ToastNotistack";
import T from "utils/constants/T";
import {
  clearCompany,
  clearCompanyTabDetails,
  getMultipleCompanies,
} from "store/reducers/companyTabDetails";
import { clearAstute } from "store/reducers/astute";
import { clearBankingSettings } from "store/reducers/companyBankingSettings";
import { clearFinancialSettings } from "store/reducers/companyFinancialSettingsTab";
import { clearKybTab } from "store/reducers/companyKybTab";
import { clearDashboard } from "store/reducers/dashboard";
import { resetDeductions } from "store/reducers/deductions";
import { clearDeductionTransactionsFilter } from "store/reducers/deductionTransactionFilter";
import { clearMenu } from "store/reducers/menu";
import { clearMyob } from "store/reducers/myob";
import { clearRegisteredEmployees } from "store/reducers/registeredEmployees";
import { clearSnackbar } from "store/reducers/snackbar";
import { clearStepper } from "store/reducers/stepper";
import { clearTimesheet } from "store/reducers/timesheet";
import { clearTransactions } from "store/reducers/transactionData";
import { clearUnregisteredEmployees } from "store/reducers/unRegisteredEmployees";
import { clearWallet } from "store/reducers/wallets";
import { clearWhiteLabellingSettings } from "store/reducers/whiteLabellingSettings";
const noSelectedCompany = {
  company_name: "",
};
// const { SERVER_URL } = ServerConstants;
// var CryptoJS = require("crypto-js");
// const secretPass = "cashdSecretkey";

// const encryptData = (text: any) => {
//   const data = CryptoJS.AES.encrypt(
//     JSON.stringify(text),
//     secretPass
//   ).toString();
//   return data
// };
// const decryptData = async (text: any) => {
//   const data = CryptoJS.AES.decrypt(
//     JSON.parse(text),
//     secretPass
//   );
//   var originalText = await data.toString(CryptoJS.enc.Utf8);
//   return JSON.parse(originalText)
// };

// let headersOptions= {
//   headers: {
//         'Content-Type': 'application/json',
//         'x-api-key': 'ddYpb7BInj9p4mwh0jKQw9he40dJ2kC7Y01uNina',
//         'Accept': '*/*',
//         'Connection': 'keep-alive',
//         'Accept-Encoding': 'gzip, deflate, br'
//       }
// }
// let headersOptions = {
//   headers: {
//     'x-api-key': 'ddYpb7BInj9p4mwh0jKQw9he40dJ2kC7Y01uNina',
//   }
// }
const verifyToken: (st: string) => boolean = (serviceToken) => {
  if (!serviceToken) {
    return false;
  }
  const decoded: KeyedObject = jwtDecode(serviceToken);
  /**
   * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
   */
  return decoded.exp > Date.now() / 1000;
};

const setSession = (serviceToken?: string | null) => {
  if (serviceToken) {
    localStorage.setItem("serviceToken", serviceToken);
    axios.defaults.headers.common.token = `${serviceToken}`;
  } else {
    localStorage.removeItem("serviceToken");
    delete axios.defaults.headers.common.token;
  }
};

// ==============================|| JWT CONTEXT & PROVIDER ||============================== //

const JWTContext = createContext<JWTContextType | null>(null);

export const JWTProvider = ({ children }: { children: React.ReactElement }) => {
  let state = useSelector((state) => state.auth);
  useEffect(() => {
    const init = async () => {
      try {
        const serviceToken = localStorage.getItem("serviceToken");
        if (serviceToken && verifyToken(serviceToken)) {
          setSession(serviceToken);
        } else {
          localStorage.clear();
          dispatch(logoutUser({ isInitialized: true }));
        }
      } catch (err) {
        dispatch(logoutUser({ isInitialized: true }));
      }
    };

    init();
  }, []);

  const login = async (email: string) => {
    await publicApi.post(`/v2/api/users/signin`, { email });
    let setObject = { email };
    localStorage.setItem("users", JSON.stringify(setObject));
  };

  const codeVerification = async (otp: string) => {
  const localStorageData: any = localStorage.getItem("users");
  let email = JSON.parse(localStorageData).email;
  const response = await publicApi.post(`/v2/api/users/verifyOTP`, {
    email,
    OTP: +otp,
  });
  
  const responseData = response.data;
  
  // Check if mobile OTP is required
  if (responseData.data?.mobileOtpRequired || 
      responseData.message?.includes("Mobile OTP sent")) {
    
    // Store email and mobile number in localStorage for mobile OTP verification
    const userMobile = responseData.data?.mobile || '';
    localStorage.setItem("pendingMobileVerification", email);

    // Update users localStorage with mobile number
    const userData = JSON.parse(localStorageData);
    userData.mobile = userMobile;
    localStorage.setItem("users", JSON.stringify(userData));
    
    // Return a flag indicating mobile OTP is required
    return { 
      success: true, 
      mobileOtpRequired: true,
      email: email 
    };
  }

     // Check if the response has the expected data structure
  if (!responseData.data || !responseData.data.userData) {
    toast("Invalid response from server", { variant: "error" });
    return { success: false, mobileOtpRequired: false };
  }

   // Extract data directly from responseData.data (not responseData.data.data)
  const { userData, staffData, companyData, multipleCompany } = responseData.data;

    // Store mobile number in localStorage
  if (userData?.mobile) {
    const existingUserData = JSON.parse(localStorageData);
    existingUserData.mobile = userData.mobile;
    localStorage.setItem("users", JSON.stringify(existingUserData));
  }

   setSession(userData.token);

    if (multipleCompany) {
    dispatch(getMultipleCompanies);
  }

   let onBoardedUserCompanyDetails = {};
  const role = get(userData, "role_id.name", "");
   dispatch(updateRole(role));

  if (userData) {
    dispatch(loginUser({ user: userData }));
  }
   if (staffData) {
    dispatch(updateStaffData({ staffData }));
  }

  if (companyData) {
    dispatch(onBoardingStatusUpdate({ onBoardedCompanyData: companyData }));

    onBoardedUserCompanyDetails = {
      company_name: get(companyData, "company_name", ""),
      _id: get(companyData, "_id", ""),
    };
  }

  dispatch(
    loggedInUserData({
      isCashDSuperAdmin: role === "superadmin",
      isEmployerAdmin: role === "employer",
      isManagerAdmin: role === "manager",
      isPayrollOfficer: role === T.PAYROLL_OFFICER,
      onBoardedCompanyDetails: onBoardedUserCompanyDetails,
    })
  );

  if (role === "superadmin") {
    dispatch(updateSelectedCompany({ selectedCompany: noSelectedCompany }));
  } else if (role === "employer") {
    dispatch(
      updateSelectedCompany({ selectedCompany: onBoardedUserCompanyDetails })
    );
  } else if (role === "manager" || role === T.PAYROLL_OFFICER) {

    dispatch(
       updateSelectedCompany({ selectedCompany: onBoardedUserCompanyDetails })
    );
  } else {
    localStorage.clear();
    logout();
    toast(T.INVALID_USER, { variant: "error" });
    return { success: false, mobileOtpRequired: false };
  }

    return { success: true, mobileOtpRequired: false };
};
  
const verifyMobileOtp = async (email: string, mobileOtp: number) => {
  try {
    if (!email) {
      toast("Session expired. Please login again.", { variant: "error" });
      return { success: false };
    }

    const response = await publicApi.post(`/v2/api/users/verifyMobileOTP`, {
      email,
      mobileOTP: mobileOtp,
    });

    const responseData = response.data;
    
    if (responseData.statusCode === 200) {
      // Clear the pending verification
      localStorage.removeItem("pendingMobileVerification");
      
      // Extract data from the correct response structure
      const { userData, staffData, companyData, multipleCompany } = responseData.data;

       // Update mobile number in localStorage if available
      if (userData?.mobile) {
        const existingUserData = localStorage.getItem("users");
        if (existingUserData) {
          const userObj = JSON.parse(existingUserData);
          userObj.mobile = userData.mobile;
          localStorage.setItem("users", JSON.stringify(userObj));
        }
      }

      // Set the session token
      setSession(userData.token);

      // Handle multiple companies if needed
      if (multipleCompany) {
        dispatch(getMultipleCompanies);
      }

      let onBoardedUserCompanyDetails = {};
      const role = get(userData, "role_id.name", "");

      // Update role in state
      dispatch(updateRole(role));

      // Update user data in state
      if (userData) {
        dispatch(loginUser({ user: userData }));
      }

      // Update staff data if available
      if (staffData) {
        dispatch(updateStaffData({ staffData }));
      }

      // Update company data if available
      if (companyData) {
        dispatch(onBoardingStatusUpdate({ onBoardedCompanyData: companyData }));

        onBoardedUserCompanyDetails = {
          company_name: get(companyData, "company_name", ""),
          _id: get(companyData, "_id", ""),
        };
      }

      // Update logged in user data
      dispatch(
         loggedInUserData({
          isCashDSuperAdmin: role === "superadmin",
          isEmployerAdmin: role === "employer",
          isManagerAdmin: role === "manager",
      isPayrollOfficer: role === T.PAYROLL_OFFICER,
          onBoardedCompanyDetails: onBoardedUserCompanyDetails,
        })
      );
         // Update selected company based on role
      if (role === "superadmin") {
        dispatch(updateSelectedCompany({ selectedCompany: noSelectedCompany }));
      } else if (role === "employer" || role === "manager" || role === T.PAYROLL_OFFICER) {
        dispatch(
          updateSelectedCompany({ selectedCompany: onBoardedUserCompanyDetails })
        );
      } else {
        localStorage.clear();
        logout();
        toast(T.INVALID_USER, { variant: "error" });
        return { success: false };
      }

      toast("Mobile verification successful!", { variant: "success" });
      return { success: true };
    } else {
      toast(responseData.message || "Mobile OTP verification failed", { variant: "error" });
      return { success: false };
    }
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || "Mobile OTP verification failed";
    toast(errorMessage, { variant: "error" });
    return { success: false };
  }
};

  const register = async (
    email: string,
    firstName: string,
    lastName: string,
    phnNo?: string,
    mobileCountryCode?: number | string
  ) => {
    // todo: this flow need to be recode as it not verified
    const numericCC = mobileCountryCode
      ? parseInt(String(mobileCountryCode).replace(/\D/g, ''), 10)
      : 61;

    const response = await publicApi.post(`/v2/api/users/signup`, {
      email,
      first_name: firstName,
      last_name: lastName,
      phone: phnNo,
      mobile: phnNo,
      phnNo: phnNo,
      mobile_country_code: numericCC,
      role: "employer",
    });
    let setObject = { email };
    localStorage.setItem("users", JSON.stringify(setObject));
    let user = response.data;
    const localStorageEmployer: any = localStorage.getItem("userInfor");
    const payload: any = JSON.parse(localStorageEmployer);
    if (user.statusCode === 200) {
      try {
        await publicApi.post(`/v2/api/users/alertEmployer`, {
          firstName: payload?.firstName,
          lastName: payload?.lastName,
          email: payload?.email,
          phnNo: payload?.phnNo,
        });
      } catch (alertErr) {
        console.warn("alertEmployer warning:", alertErr);
      }
    }
    if (
      localStorage.getItem("users") !== undefined &&
      localStorage.getItem("users") !== null
    ) {
      user = {
        email,
        name: `${firstName} ${lastName}`,
      };
    }
    localStorage.setItem("users", JSON.stringify(user));
  };
  const logout = () => {
    setSession(null);
    localStorage.clear();
    // localStorage.removeItem("users");
    // localStorage.removeItem("authenticated_user");
    // localStorage.removeItem("email");
    // localStorage.removeItem("staffData");
    // localStorage.removeItem("companyData");
    dispatch(clearWhiteLabellingSettings());
    dispatch(clearWallet());
    dispatch(clearUnregisteredEmployees());
    dispatch(clearTransactions());
    dispatch(clearTimesheet());
    dispatch(clearStepper());
    dispatch(clearSnackbar());
    dispatch(clearRegisteredEmployees());
    dispatch(clearMyob());
    dispatch(clearMenu());
    dispatch(clearDeductionTransactionsFilter());
    dispatch(resetDeductions());
    dispatch(clearDashboardSearch());
    dispatch(clearDashboard());
    dispatch(clearCompanyTabDetails());
    dispatch(clearKybTab());
    dispatch(clearFinancialSettings());
    dispatch(clearBankingSettings());
    dispatch(clearAstute());
    dispatch(clearAuth());
    dispatch(clearCompany());
    dispatch(logoutUser({ isInitialized: true }));
  };

  const resetPassword = async (email: string) => {};

  const updateProfile = () => {};

  if (state.isInitialized !== undefined && !state.isInitialized) {
    return <Loader />;
  }

  const resendOtp = async (email: string) => {
    await publicApi.post(`/v2/api/users/resendOTP`, { email });
  };

   const resendMobileOtp = async (email: string): Promise<void> => {
  try {
    await publicApi.post(`/v2/api/users/resendMobileOTP`, { email });
  } catch (error) {
    console.error('Failed to resend mobile OTP:', error);
    throw new Error('Unable to resend mobile OTP. Please try again.');
  }
};

  return (
    <JWTContext.Provider
      value={{
        ...state,
        login,
        logout,
        register,
        codeVerification,
        verifyMobileOtp,
        resetPassword,
        resendMobileOtp,
        updateProfile,
        resendOtp,
      }}
    >
      {children}
    </JWTContext.Provider>
  );
};

export default JWTContext;
